export default "__VITE_ASSET__M_b0jwuV__"